import { render, staticRenderFns } from "./box-detail-popu.vue?vue&type=template&id=38bc9354"
import script from "./box-detail-popu.vue?vue&type=script&lang=js"
export * from "./box-detail-popu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports